import { useEntityIdSelector } from '../../../redux/entity-id-selector.hook';
import { priceUnitsAPI } from '../redux/price-units.slice';

export function usePriceUnit(id?: string | null) {
  const { entity: priceUnit } = useEntityIdSelector(priceUnitsAPI, id);
  return { priceUnit };
}
